<template>
  <el-dialog
    :visible.sync="visible"
    width="900px"
    :before-close="onClose"
    title="Sửa nhân sự coi thi, chấm thi"
    center
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="140px"
      label-position="top"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Tìm nhân sự <span class="text-danger">*</span></label>
            <el-select
              v-model="form.user_id"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="Nhập mã học viên, số điện thoại, tên học viên"
              ref="new_student"
              class="w-100"
              :remote-method="remoteMethod"
              :loading="loading"
              @change="handleSelectUser"
              disabled
            >
              <el-option
                v-for="user in userSearch"
                :key="user.id"
                :label="user.id + 100000 + ' - ' + user.name"
                :value="user.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Loại nhân sự<span class="text-danger">*</span></label>
            <el-select
              class="w-100"
              clearable
              v-model="form.type_id"
              filterable
              placeholder="Chọn loại nhân sự"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="+item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Hình thức làm việc <span class="text-danger">*</span></label>
            <el-select
              class="w-100"
              clearable
              v-model="form.type_work_id"
              filterable
              placeholder="Chọn hình thức làm việc"
              :disabled="isWorkTypeLocked"
            >
              <el-option
                v-for="item in workTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="+item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-if="form.type_work_id === offlineOptions" class="col-md-6">
          <div class="form-group">
            <label
              >Cơ sở trực test offline<span class="text-danger">*</span></label
            >
            <el-select
              class="w-100"
              clearable
              v-model="form.branch_id"
              filterable
              placeholder="Chọn văn phòng trực offline"
            >
              <el-option
                v-for="item in branches"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-6" v-if="form.type_work_id === onlineOptions">
          <div class="form-group">
            <label>Link Zoom<span class="text-danger">*</span></label>
            <el-input v-model="form.link_test" style="width: 100%" placeholder="Nhập link zoom" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div
            class="form-group d-flex align-items-center h-100"
            style="height: 56px"
          >
            <el-form-item class="mb-0 w-100">
              <el-switch
                v-model="form.status"
                active-text="Hiển thị"
                inactive-text="Ẩn"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <el-button @click="onClose">Hủy bỏ</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading"
          >Xác nhận</el-button
        >
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  ADMIN_PROFILE_TYPE,
  WORK_TYPE,
  OFFLINE,
  ONLINE,
  ENTRANCE_EXAM_MARKING,
} from "@/core/option/adminProfile";
import { SEARCH_CUSTOMER_BY_OR_ID } from "@/core/services/store/user/users.module";
import { UPDATE_MARKING_ADMIN } from "@/core/services/store/marking/admin.module";

export default {
  name: "AdminEditModal",
  props: {
    visible: Boolean,
    admin: Object,
    branches: Array,
  },
  data() {
    return {
      typeOptions: ADMIN_PROFILE_TYPE,
      workTypeOptions: WORK_TYPE,
      offlineOptions: OFFLINE,
      onlineOptions: ONLINE,
      form: {
        id: "",
        user_id: "",
        type_id: "",
        type_work_id: "",
        is_fixed_schedule: 1,
        link_test: "",
        mark_level: "",
        branch_id: "",
        status: 1,
      },
      rules: {
        type_id: [
          {
            required: true,
            message: "Vui lòng chọn loại nhân sự",
            trigger: "change",
          },
        ],
        type_work_id: [
          {
            required: true,
            message: "Vui lòng chọn hình thức làm việc",
            trigger: "change",
          },
        ],
      },
      loading: false,
      userSearch: [],
    };
  },
  computed: {
    isWorkTypeLocked() {
      return Number(this.form.type_id) === ENTRANCE_EXAM_MARKING;
    },
  },
  watch: {
    admin: {
      handler(val) {
        if (val) {
          this.form = {
            id: val.id || "",
            user_id: val.user_id || "",
            type_id: val.type_id || 0,
            type_work_id: val.type_work_id || "",
            is_fixed_schedule: val.is_fixed_schedule || 1,
            link_test: val.link_test || "",
            mark_level: val.mark_level || "",
            branch_id: val.branch_id || "",
            status: val.status || 1,
          };
          this.userSearch = [
            {
              id: val.user_id,
              name: val.user_name,
            },
          ];
        }
      },
      immediate: true,
    },
    "form.type_id"(val) {
      if (Number(val) === ENTRANCE_EXAM_MARKING) {
        this.applyEntranceExamWorkTypeRules();
      }
    },
  },
  methods: {
    applyEntranceExamWorkTypeRules() {
      this.form.type_work_id = ONLINE;
      this.form.branch_id = "";
    },
    onClose() {
      this.$emit("close");
    },
    async onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        await this.$store
          .dispatch(UPDATE_MARKING_ADMIN, this.form)
          .then(() => {
            this.$message.success("Cập nhật thành công!");
            this.$emit("updated");
            this.onClose();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    async remoteMethod(query) {
      if (query !== "" && query.length >= 6 && query.length <= 10) {
        this.loading = true;
        try {
          const params = {
            search_customer_by_phoneOrId: query,
            limit: 10000,
            status: 1,
            is_staff: 0,
          };
          const res = await this.$store.dispatch(
            SEARCH_CUSTOMER_BY_OR_ID,
            params
          );
          this.userSearch = res.data.data;
        } catch (e) {
          this.$message.error("Không thể tìm kiếm người dùng");
        } finally {
          this.loading = false;
        }
      } else {
        this.userSearch = [];
      }
    },
    handleSelectUser(userId) {
      const selectedUser = this.userSearch.find((u) => u.id === userId);
      if (selectedUser) {
        this.form.user_name = selectedUser.name;
      }
    },
  },
};
</script>
